<script lang="ts">
    import FeatherIcon  from "svelte-feather-icon";
    import Link from "svelte-link";
    import { Button, Col, Form, Input, Label, Modal, ModalBody, ModalHeader, Row } from "sveltestrap";
    import { Cancel, CreateTag, href, Save, Tagcolor, TagName, Tags } from "../../../utils/Constant/Constant";
    let open:boolean = false;
    function toggle() {
      open = !open
    }
</script>
<li>
    <span class="main-title"> {Tags}
        <span class="pull-right">
            <Link href={href} on:click={toggle}>
                <FeatherIcon icon="plus-circle" />
            </Link>
        </span>
    </span>
</li>
<div class="modal fade modal-bookmark" id="createtag" tabindex="-1" role="dialog" aria-hidden="true">
    <Modal isOpen={open} {toggle} class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <ModalHeader>{CreateTag}
          <Button class="btn-close" on:click={toggle}></Button>
        </ModalHeader>
        <ModalBody>
          <Form class="form-bookmark needs-validation" novalidate>
            <Row class="row g-2">
              <Col md="12" class="mb-3 mt-0">
                <Label>{TagName}</Label>
                <Input type="text" required autocomplete="off"/>
              </Col>
              <Col md="12" class="mb-3 mt-0">
                <Label>{Tagcolor}</Label>
                <Input class="form-color d-block" type="color" value="#563d7c"/>
              </Col>
            </Row>
            <Button color="secondary" on:click={toggle}>{Save}</Button>
            <Button color="primary" on:click={toggle}>{Cancel}</Button>
          </Form>
        </ModalBody>
      </div>
    </Modal>
</div>